import React from 'react';
import { View, Text, StyleSheet, Dimensions } from 'react-native';

const screenWidth = Dimensions.get('window').width;

const LandlordAndAgentInfo = ({landlord,authState}) => {



  return (
    <View style={styles.container}>
      {/* Landlord Card */}
      <View style={styles.card}>
        <Text style={styles.cardTitle}>Landlord Info</Text>
        <View style={styles.infoBox}>
          <Text style={styles.label}>
            Name: {`${landlord?.title ?? ''} ${landlord?.first_name ?? ''} ${landlord?.last_name ?? ''}`}
          </Text>
        </View>
        <View style={styles.infoBox}>
          <Text style={styles.label}>
            Address: {`${landlord?.correspondece_address ?? ''} ${landlord?.post_code ?? ''}`}
          </Text>
        </View>
        <View style={styles.infoBox}>
          <Text style={styles.label}>
            Email: {landlord?.email ?? ''}
          </Text>
        </View>
        <View style={styles.infoBox}>
          <Text style={styles.label}>
            Contact Number: {landlord?.number ?? ''}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default LandlordAndAgentInfo;

const styles = StyleSheet.create({
  container: {
    flexDirection: screenWidth < 768 ? 'column' : 'row',
    justifyContent: 'space-between',
    gap: 16,
    padding: 10,
  },
  card: {
    flex: 1,
    backgroundColor: '#fff',
    padding: 16,
    marginBottom: 16,
    borderRadius: 10,
    position: 'relative',
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 20,
    elevation: 5,
  },
  cardTitle: {
    fontWeight: '600',
    fontSize: 16,
    marginBottom: 10,
    textTransform: 'capitalize',
  },
  infoBox: {
    marginBottom: 8,
  },
  label: {
    fontSize: 14,
    color: '#333',
  },
});
